/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': "Demandez de l'aide à votre équipe ou administrateur.",
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': "Nous n'avons trouvé aucun résultat pour cette recherche"
};